"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var Page_1 = __importDefault(require("../../components/Page"));

var LineItem_1 = __importDefault(require("../../components/LineItem"));

var TransactionDetails_1 = __importDefault(require("../../data-providers/TransactionDetails"));

var ReceiptPage = function ReceiptPage(_a) {
  var match = _a.match;
  return react_1.default.createElement(Page_1.default, {
    title: "Receipt"
  }, react_1.default.createElement(TransactionDetails_1.default, {
    asset: match.params.asset,
    txHash: match.params.txHash,
    render: function render(err, tx) {
      if (err) {
        return "Error: " + err.message;
      }

      if (!err && !tx) {
        return 'Loading...';
      }

      return react_1.default.createElement("div", null, react_1.default.createElement(LineItem_1.default, {
        name: "From",
        value: tx.from
      }), react_1.default.createElement(LineItem_1.default, {
        name: "To",
        value: tx.to
      }), react_1.default.createElement(LineItem_1.default, {
        name: "Amount",
        value: tx.displayValue + " " + tx.assetName
      }), tx.message && react_1.default.createElement(LineItem_1.default, {
        name: "Message",
        value: tx.message
      }));
    }
  }));
};

exports.default = ReceiptPage;